import React, { useState, useEffect } from 'react';
import { Stack, Typography, Switch, CircularProgress, Tooltip } from '@mui/material';
import { saveForecast } from '../../../repositories/HttpRepository';
import { toast } from 'react-toastify';
import { ToastMessage } from '../../../constants/toastMessage';

const AutoModeSwitcher = ({ forecastId, initialIsAutoMode, onSaveSuccess }) => {
  const [isAutoMode, setIsAutoMode] = useState(initialIsAutoMode);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (!isSaving) setIsAutoMode(initialIsAutoMode);
  }, [initialIsAutoMode]);

  const handleChange = async (e) => {
    if (isSaving) return;
    const newValue = e.target.checked;
    setIsAutoMode(newValue);
    setIsSaving(true);
    try {
      const payload = [{ id: forecastId, is_auto_mode: newValue }];
      const response = await saveForecast(payload);
      if (!response.ok) {
        setIsAutoMode(!newValue);
        toast.error(ToastMessage.UPDATED_FAIL);
      } else {
        if (onSaveSuccess) onSaveSuccess(payload);
        toast.success(ToastMessage.UPDATED_SUCCESS);
      }
    } catch {
      setIsAutoMode(!newValue);
      toast.error(ToastMessage.UPDATED_FAIL);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Stack direction="row" sx={{ alignItems: 'center', gap: 0.5 }}>
      {isSaving ? (
        <CircularProgress size={14} />
      ) : (
        <Typography variant="caption" sx={{ color: 'text.secondary' }}>
          {isAutoMode ? 'Auto' : 'Manual'}
        </Typography>
      )}
      <Tooltip title={isAutoMode ? 'Disable the auto-forecast rules and manually enter the number to create advanced tickets' : ''}>
        <Switch size="small" checked={isAutoMode} onChange={handleChange} />
      </Tooltip>
    </Stack>
  );
};

export default AutoModeSwitcher;
